<template>
  <div id="xyjRefresh">
    <div>
      <div v-if="config.pullDownRefresh && !config.isSelfUpLoadStyle"
           :style="{height: config.pullDownRefresh.stop?config.pullDownRefresh.stop + 'px': '1rem',top:config.pullDownRefresh.stop?'-'+config.pullDownRefresh.stop + 'px': '-1rem'}"
           class="listLoading"
      >
        <div :style="{transform: 'rotate('+dge+')'}"
             :class="{animate: rotateStatus}"
             class="font"
        >
          <i class="iconfont icon-jiazaiyuanhuan"></i>
          <i class="iconfont icon-jiazaiyuanhuan-ban"></i>
        </div>
        <div v-if="!config.isNoneDownText"
             class="text"
        >
          <slot name="downText">
            {{ text }}
          </slot>
        </div>
      </div>
      <slot v-if="config.isSelfUpLoadStyle"
            name="upLoadStyle"
      ></slot>
      <slot></slot>
      <div class="downText">
        <slot name="upload"></slot>
      </div>
    </div>
  </div>
</template>

<script>
// 其中的字体图标引用那蝶项目 找UI下载svg引用到字体图标当中
export default {
  name: "XyjRefresh",
  props: {
    config: {
      type: Object,
      default() {
        return {
          parentEle: "",
          isSelfUpLoadStyle: false, // 是否自定义下拉刷新样式
          isNoneDownText: false, // 是否不展示下拉刷新文案
          isForbidden: false,
          pullDownRefresh: false, // 是否支持下拉刷新
          pullUpLoad: false // 是否支持上拉加载
        };
      }
    },
    scroll: {
      type: Function,
      default() {
        return function() {};
      }
    },
    scrollend: {
      type: Function,
      default() {
        return function() {};
      }
    },
    pullingup: {
      type: Function,
      default() {
        return function() {};
      }
    },
    pullingdown: {
      type: Function,
      default() {
        return function() {};
      }
    }
  },
  data() {
    return {
      scrollEle: "", // 滚动对象
      text: "下拉刷新", // 下拉文案
      dge: 0, // 初始下拉的角度
      rotateStatus: false, // 图标滚动状态
      downLoading: false // 下拉刷新的状态
    };
  },
  watch: {
    config: function(data) {
      if (data.isForbidden) {
        this.scrollEle.disable();
      } else {
        this.scrollEle.enable();
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.initScroll();
    }, 350);
    this.$emit("rendered");
  },
  methods: {
    initScroll() {
      if (this.scrollEle) {
        this.scrollEle.destroy();
      }
      const self = this;
      var str = "";
      if (this.jquery(".rootapp").length == 2) {
        var ele = this.jquery(".rootapp.slide-left-enter").find("#xyjRefresh");
        str = ele.get(0);
        if (ele.length == 0) {
          str = this.jquery(".rootapp.slide-left-enter-active").find("#xyjRefresh").get(0);
        }
      } else {
        str = "#xyjRefresh";
      }
      if (self.config.parentEle) {
        str = self.config.parentEle + ">" + str;
      }
      this.scrollEle = new this.$BScroll(str, {
        pullDownRefresh: self.config.pullDownRefresh,
        pullUpLoad: self.config.pullUpLoad ? self.config.pullUpLoad : false,
        click: true,
        probeType: 3,
        bounceTime: 500,
        deceleration: 0.001,
        swipeTime: 2500,
        // stopPropagation: true,
        swipeBounceTime: 500
      });
      if (this.config.isForbidden) {
        this.scrollEle.disable();
      } else {
        this.scrollEle.enable();
      }
      this.scrollEle.on("scroll", function(obj) {
        if (typeof self.scroll !== "function") {
          return false;
        }
        if (typeof self.config.pullDownRefresh == "object") {
          const limit = (self.config.pullDownRefresh.stop ? self.config.pullDownRefresh.stop : 100);
          self.dge = limit / obj.y * 100 + "deg";
          if (obj.y > limit && !self.downLoading) { // 当下拉距离超过限制距离 并且当前不是下拉刷新状态
            self.text = "松开立即刷新";// 下拉文案
          } else if (obj.y == 0) {
            self.refreshFinish();
          }
        }
        self.scroll(obj);
      });

      this.scrollEle.on("scrollEnd", function(obj) {
        self.scrollend(obj);
      });
      this.scrollEle.on("pullingUp", function(msg) {
        self.pullingup();
      });
      if (self.config.pullDownRefresh) {
        this.scrollEle.on("pullingDown", function() {
          self.rotateStatus = true; // 让圆圈滚动
          self.downLoading = true; // 当前下拉刷新的状态
          self.text = "正在刷新..."; // 下拉文案
          if (self.config.pullDownRefresh) {
            self.pullingdown();
          }
        });
      }
    },
    // 重置上拉刷新 下拉加载 并重新计算滚动高度
    refreshFinish() {
      if (this.scrollEle) {
        this.scrollEle.finishPullUp();
        if (this.config.pullDownRefresh) {
          this.scrollEle.finishPullDown();
        }
        this.scrollEle.refresh();
        this.text = "下拉刷新";// 下拉文案
        this.downLoading = false; // 下拉状态
        this.rotateStatus = false; // 让圆圈不滚动
      }
    }
  }
};
</script>

<style>
  /* 因为此处设置的高度是100% 不是100vh 所以引用此组件 最外层要有个100vh的div进行包裹 */
  #xyjRefresh {
    position: relative;
    width: 100%;
    height: 100%;
  }
  /* 这里是下拉刷新的动画 */
  .listLoading {
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 0.25rem;
    z-index: 1;
  }

  .text {
    font-size: 0.24rem;
    color: #969696;
    margin-top: 0.2rem;
  }

  /* 上拉加载的样式 */
  .downText {
    width: 100%;
    min-height: 0.28rem;
    color: #AAAAAA;
    font-size: 0.24rem;
    line-height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .downText span{
    margin-left: 0.2rem;
  }
  .font {
    position: relative;
    width: 0.32rem;
    height: 0.32rem;
    border-radius: 50%;
  }
  .font i {
    position: absolute;
    z-index: 2;
    font-size: 0.32rem;
  }
  .icon-jiazaiyuanhuan-ban {
    color: #DCDCDC;
  }
  .icon-jiazaiyuanhuan {
    color: #1e62fc;
  }
  .animate {
    transform-origin: center center;
    animation: mymove 3s infinite linear;
  }

  @keyframes mymove {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(720deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/xyjRefresh.vue